import React, { useEffect, useState } from 'react';
import CookieConsent from "react-cookie-consent";
import { FnAxios, I18n, RouterDOM } from "utilities/utilities";
import { ApiCookie } from "enum/api";
import { APIStatusCode } from 'enum/enum';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { Button, Typography } from '@mui/material';

const CookieConsentProvider = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();

    const [sIPAddress, setsIPAddress] = useState<any>(null);

    const Router = RouterDOM();
    useEffect(() => {
        let sRoute = Router.GetCurrentRoute();
        if (sIPAddress) handleAddCookieHistory(sRoute);
    }, [Router, sIPAddress]);

    const handleAddCookieHistory = (sRoute) => {
        AxiosFn.Post(ApiCookie.CookieHistory, { sIPAddress: sIPAddress, sRoute: sRoute === "" ? "/Home" : sRoute }, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) console.log("History Route > ", result);
        });
    };

    const GetPublicIP = async (isAccept) => {
        let result = await axios.get("https://myexternalip.com/json");
        if (result?.data && result?.data.ip) {
            setsIPAddress(result.data.ip);
            handleAddCookie(isAccept, result.data.ip);
        } else {
            setsIPAddress(result.data);
            handleAddCookie(isAccept, result.data);
        }
    };

    const handleAddCookie = (isAccept, sIP) => {
        let objParam = {
            sIPAddress: sIP,
            isAccept: isAccept,
            sRoute: null,
        };
        AxiosFn.Post(ApiCookie.Cookie, objParam, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) window.location.reload();
        });
    };

    return (
        <CookieConsent
            location="bottom"
            buttonText={I18n.SetText("accept")}
            cookieName="myAwesomeCookieName"
            expires={150}
            overlay
            style={{ background: "rgb(220 173 62 / 91%)", zIndex: '99999', alignItems: 'center', }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px", borderRadius: '30px', }}

            //กดยอมรับ
            onAccept={(acceptedByScrolling) => {
                GetPublicIP(!acceptedByScrolling);
            }}

        //ไม่กดยอมรับ
        // enableDeclineButton={false}
        // onDecline={() => {
        //     alert("ไม่ยินยอม!");
        // }}

        //ยอมรับให้อัตโนมัติ ถ้า Scroll เกินกำหนด
        // acceptOnScroll={true}
        // acceptOnScrollPercentage={50}
        // onAccept={(byScroll) => {
        //     alert(`consent given. \n\n By scrolling? ${byScroll}`);
        // }}
        >
            {/* เว็บไซต์นี้ใช้คุกกี้ <br/>
            <span style={{ fontSize: "16px" }}>เว็บไซต์ของเราใช้คุกกี้เพื่อพัฒนาประสิทธิภาพ และประสบการณ์ที่ดีในการใช้เว็บไซต์ของท่าน ท่านสามารถศึกษารายละเอียดได้ที่</span>
            <a href={"/privacypolicy"}>นโยบายคุกกี้</a> */}
            <span style={{ fontSize: "16px", color: '#f1e737' }}>{I18n.SetText("cookies")}</span><br />
            <span style={{ fontSize: "13px" }}>{I18n.SetText("cookiescontent") + " "}</span>
            <a target="_blank" rel="noreferrer" style={{ fontSize: "13px", color: '#fff23c', textDecoration: 'underline', cursor: 'pointer', }} href={process.env.REACT_APP_FRONTEND_URL + "Privacypolicy?1"} >{I18n.SetText("policy")}</a>  
            {/* <Button variant="text" style={{ paddingBottom: '11px', paddingLeft: '1%', fontSize: '14px'}}><a onClick={()=> { navigate("/Privacypolicy?1"); }} target="_blank" rel="noreferrer"  style={{ fontSize: "13px", color: '#fff23c', textDecoration: 'underline', cursor: 'pointer', }}>{I18n.SetText("policy")}</a></Button>     */}
        </CookieConsent>
    )
}
export default CookieConsentProvider;